import {MODALITY} from '@domain/model/Account/Subscription/Subscription';

export const TEXT = {
  PANEL_TITLE: {id: 'account_yourPlan.planPanel.modifyPlan'},
  REASSURANCE1: {id: 'myLK.subscription.reassurancetext1'},
  REASSURANCE2: {id: 'myLK.subscription.reassurancetext2'},
  MODALITY_MONTHLY_CTA: {id: 'exp_subscription_adoption.monthly.cta'},
  MODALITY_BIMONTHLY_CTA: {id: 'exp_subscription_adoption.bimonthly.cta'},
  MODALITY_QUARTERLY_CTA: {id: 'exp_subscription_adoption.quarterly.cta'},
  MODALITY_ON_DEMAND_CTA: {id: 'exp_subscription_adoption.ondemand.cta'},
  PLANS_TITLE: {id: 'exp_subscription_adoption.plans_title'},
  CTA_CANCEL: {id: 'account_yourPlan.cancelPlan.cancelCta'},
  MSG_SUCCESS_PLAN_CANCEL: {id: 'account_yourPlan.cancelPlan.successToast'},
  MSG_SUCCESS_PLAN_UPDATE: {id: 'account_yourPlan.updatePlan.successToast'},
  MSG_ERROR: {id: 'account.frequency.toast_error'},
};

export const CTA_TEXT = {
  [MODALITY.MONTHLY]: TEXT.MODALITY_MONTHLY_CTA,
  [MODALITY.BIMONTHLY]: TEXT.MODALITY_BIMONTHLY_CTA,
  [MODALITY.QUARTERLY]: TEXT.MODALITY_QUARTERLY_CTA,
  [MODALITY.ON_DEMAND]: TEXT.MODALITY_ON_DEMAND_CTA,
} as const;

export const IDS = {
  SUBSCRIPTION_CTA: 'SubscriptionMaincta',
} as const;
